module.exports = __webpack_public_path__ + "img/norway.1b627670.svg";